import { type Ref, watch } from 'vue'

export type AsyncFunction = () => Promise<void>
export type StopFunction = () => void

export function useIntersectionObserver(
  element: Ref<HTMLElement | null>,
  callback: () => Promise<void> | void,
): StopFunction {
  const observer = new IntersectionObserver((entries) => {
    const e = entries.find((e) => e.isIntersecting)
    if (e !== undefined) {
      void callback()
    }
  })
  const stop = watch(
    element,
    (value, oldValue) => {
      if (oldValue !== null && oldValue !== undefined) {
        observer.unobserve(oldValue)
      }
      if (value !== null) {
        observer.observe(value)
      }
    },
    {
      immediate: true,
    },
  )

  return () => {
    stop()
    observer.disconnect()
  }
}
